import { useEffect, useContext, useState, useCallback } from 'react';
import { useModal } from 'src/services/modal';
import useRemainingSeconds from 'src/hooks/useRemainingSeconds';
import { AppContext } from 'src/store/app-context';
import isWithinLastMinute from 'src/util/isWithinLastMinute';
const useRefreshSessionModal = ({ api, context, url }) => {
  const { closeModal, open, openModal } = useModal();
  const { lastActive } = useContext(AppContext);

  const { secondsLeft } = useRemainingSeconds({
    context: context,
  });

  const { refreshSession, isLoggedIn } = useContext(context);

  const ONE_MINUTE_IN_SECONDS = 60;
  const [hasBeenShown, setHasBeenShown] = useState(false);

  // Using useCallback to memoize handleRefresh
  const handleRefresh = useCallback(async () => {
    try {
      const res = await api.post(url);
      refreshSession(res.data.exp);
      setHasBeenShown(false);
      closeModal();
    } catch (err) {
      console.error(err);
    }
  }, [api, url, refreshSession, closeModal]);

  useEffect(() => {
    const shouldShow = secondsLeft < ONE_MINUTE_IN_SECONDS && !hasBeenShown && !open && isLoggedIn;
    if (shouldShow) {
      const activeWithinLastMinute = isWithinLastMinute(lastActive);
      if (activeWithinLastMinute) {
        handleRefresh();
        return;
      }

      openModal();
      setHasBeenShown(true);
    }
  }, [hasBeenShown, open, openModal, secondsLeft, isLoggedIn, lastActive, handleRefresh]);

  return { handleRefresh, secondsLeft, closeModal, open };
};

export default useRefreshSessionModal;
